import { Component, EventEmitter, Input, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import { CallLogsRegister } from '../call-logs-register';
import { CallLogsFilterOptions } from '../models/call-logs-filter-option';

import { CallLogsRegisterOptions } from '../models/call-logs-register-options';
import { CallLogsRegisterListItem } from '../models/call-logs-register-results.model';
import * as CallLogsActions from '../state/call-logs-register.actions';
import { selectQuickFilters } from '../state/call-logs-register.selectors';
@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-call-logs-register',
    templateUrl: './call-logs-register.component.html',
    standalone: false
})
export class CallLogsRegisterComponent extends CallLogsRegister {
   @Input() get extensionId(): number {
      return this._extensionId;
   }

   @Input() get extensionIds(): number[] {
      return this._extensionIds;
   }

   set extensionId(value: number) {
      this._extensionId = value;
      this.filters = this.buildFilters();
   }
   set extensionIds(value: any[]) {
      if (value != null) {
         this._extensionIds = value.map((ext) => ext.extension.extensionId);
         this.filters = this.buildFilters();
      }
   }

   @Output() filtersChanged = new EventEmitter<CallLogsFilterOptions[]>();

   protected selectQuickFilters(): (state: object) => CallLogsRegisterOptions | null {
      return selectQuickFilters;
   }

   private _extensionId: number;

   private _extensionIds: number[];

   constructor(public store: Store) {
      super(store);

      this.filters = this.buildFilters();

      this.columns = [
         'startDate',
         'callDirection',
         'callSource',
         'callDestination',
         'destinationNumber',
         'callDisposition',
         'callDuration',
         'detail',
      ];
   }

   onOpenDialog(event: { callLogs: CallLogsRegisterListItem }) {
      this.store.dispatch(CallLogsActions.openDialog(event));
   }

   ngOnChanges(changes: SimpleChanges) {
      if (changes['extensionId'] && !changes['extensionId'].firstChange) {
         this.store
            .select(selectQuickFilters)
            .pipe(take(1))
            .subscribe((quickFilters) => {
               if (quickFilters) {
                  this.filters = this.buildFilters();
                  this.store.dispatch(
                     CallLogsActions.callLogsRegisterInitialFilter({ filters: this.filters, quickFilters: quickFilters })
                  );
                  this.store.dispatch(this.actions.pageEnter());
               }
            });
      }
   }

   onListen(event: CallLogsActions.ListenToRecordingModel) {
      this.store.dispatch(CallLogsActions.listenToRecording({ callRecording: event }));
   }

   private buildFilters(): CallLogsFilterOptions[] {
      let filters: CallLogsFilterOptions[] = [];
      if (this.extensionId && this.extensionId != 0)
         filters.push({
            field: 'CallSegments.ExtensionId',
            operation: FilterOperations.EqualTo,
            type: 'numeric',
            value: this.extensionId,
         });
      if (this.extensionIds && this.extensionIds.length > 0)
         this.extensionIds.forEach((id) => {
            filters.push({
               field: 'CallSegments.ExtensionId',
               operation: FilterOperations.EqualTo,
               type: 'numeric',
               value: id,
            });
         });

      //Edge case of no ext ids to prohibit return of all records due to null filters
      if (filters.length === 0) {
         filters.push({
            field: 'CallSegments.ExtensionId',
            operation: FilterOperations.EqualTo,
            type: 'numeric',
            value: 0,
         });
      }
      return filters;
   }
}
